import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { CycleSection } from './components/CycleSection';
import { ProductIntroSection } from './components/ProductIntroSection';
import { LevelsSection } from './components/LevelsSection';
import { BonusSection } from './components/BonusSection';
import { WhyWorksSection } from './components/WhyWorksSection';
import { ComparisonSection } from './components/ComparisonSection';
import { ResultsSection } from './components/ResultsSection';
import { ForWhoSection } from './components/ForWhoSection';
import { OfferSection } from './components/OfferSection';
import { FinalCTASection } from './components/FinalCTASection';
import { MiniTestimonial } from './components/MiniTestimonial';
import { TestimonialsSection } from './components/TestimonialsSection';
import { MockupSection } from './components/MockupSection';
import { InlineCTA } from './components/InlineCTA';
export function App() {
  return <div className="w-full min-h-screen bg-[#0a0a0a] text-white" data-id="element-0">
      {/* HOOK + PRODUCT REVEAL */}
      <HeroSection data-id="element-1" />
      <MockupSection data-id="element-2" />

      {/* PROBLEM AWARENESS */}
      <ProblemSection data-id="element-3" />

      {/* SOLUTION REVEAL */}
      <ProductIntroSection data-id="element-4" />

      <MiniTestimonial quote="El módulo de control y respiración cambió totalmente cómo entro a la intimidad." name="Tomás" age={31} data-id="element-5" />

      <BonusSection data-id="element-6" />

      {/* RESULTADOS + OFERTA (la oferta ya no aparece tan arriba) */}
      <ResultsSection data-id="element-7" />
      <OfferSection data-id="element-8" />

      {/* SOCIAL PROOF */}
      <TestimonialsSection data-id="element-9" />

      {/* REFUERZO */}
      <WhyWorksSection data-id="element-10" />
      <ComparisonSection data-id="element-11" />
      <ForWhoSection data-id="element-12" />

      {/* CIERRE */}
      <FinalCTASection data-id="element-13" />
    </div>;
}